import React, { useState,useContext,useEffect } from "react"
import hero from './../data/Unit.json';
import skills from './../data/skill.json';
import leaderSkills from './../data/leaderSkills.json';
import { AppContext } from "./../context/AppContext";
import './../App.css';
import './../styles/LeaderSkill.scss';

export function EsperData(props) {
    let unit = props.unit
    const {searchKey,getLeaderSkillsDescription,getLeaderSkillIcon} = useContext(AppContext);
    const descriptionReplace = (skill,description) => {
        //console.log(description);
        let tempDescription = searchKey(description);
        //console.log(tempDescription);
        let temp = skill.DesNum.split(";")
        //if(temp)
        if(tempDescription !== undefined) {
            if(temp[0] !== undefined)
                tempDescription = tempDescription.replace(/\$\{num1\}/,temp[0]);
            if(temp[1] !== undefined)
                tempDescription = tempDescription.replace(/\$\{num2\}/,temp[1]);
            if(temp[2] !== undefined)
                tempDescription = tempDescription.replace(/\$\{num3\}/,temp[2]);
            if(temp[3] !== undefined)
                tempDescription = tempDescription.replace(/\$\{num4\}/,temp[3]);
            if(temp[4] !== undefined)
                tempDescription = tempDescription.replace(/\$\{num5\}/,temp[4]);
        }
        
        //console.log(description);
        return formatText(tempDescription);
    }
    const formatText = (text) => {
        // #48fdda blue = A102
        // #f8434c red = A105
        // #53eed2 vert = A104
        let str = "";
        if(text !== undefined) {
            str = text.replaceAll(/<(\/*)A102[^>]*>/g,'<span class="colorBlue">');
            str = str.replaceAll(/<(\/*)A105[^>]*>/g,'<span class="colorRed">');
            str = str.replaceAll(/<(\/*)A104[^>]*>/g,'<span class="colorGreen">');
            str = str.replaceAll('</>',"</span>");
        }
        return str;
    }
    const levelUpReplace = (text,TextReplace) => {
        let temp = searchKey(text);
        if(temp !== undefined) {
            let tab = TextReplace.split(";");
            temp = temp.replace(/\${Num}/g,tab[1]);
        }
        return temp;
    }
    const getBackgroundForStar = (star) => {
            //legendary : from-[#ffdf3f] to-[#ffb22a]
            //epic : from[#d733fa] to-[#fd31fa]
            // rare : from[#34d2ff] to[#02fffd]
        switch(star){
            case 3:
                return "from-[#34d2ff] to-[#02fffd]";
            case 4:
                return "from-[#d733fa] to-[#fd31fa]";
            case 5:
                return "from-[#ffdf3f] to-[#ffb22a]";
            default:
                return "";
        }
    }
    const displayStarHero = (nb) => {
		let stars = [];
		for(let i = 0; i < nb; i++){
			stars.push(<div key={i} className="z-20 self-end mb-1"><img className='w-[16px]' src={`/img/star.png`} alt="star" /></div>);
		}
		return stars;
	}

    return(
        <>
        <div className={`px-2 z-20 flex flex-row unit-${unit.ID} justify-between border-t border-l border-r rounded-t bg-gradient-to-b ${getBackgroundForStar(unit.InitialStar)} bg-opacity-50`}>
                <div className='text-center customTitle text-3xl text-white w-full flex flex-row justify-between items-center p-2'>
                    <div><img alt="type" src={`img/type/UnitJob${unit.TypeID}.png`} style={{ width: '40px' }} className='rounded-tr-lg rounded-bl-lg' /></div>
                    <div className='md:hidden h-[50px]'><img className='rounded-full w-full h-full' src={`img/charArt/Tex_UI_${unit.EnglishName}_CharArt${unit.ID}_256.png`} alt="avatar"/></div>
                    <div className='text-black '>{searchKey("Unit;NickName;" + unit.ID)}<span className="text-xs"> ({searchKey(unit.Name)})</span></div>
                    <div className='flex flex-row'>{displayStarHero(unit.InitialStar)}</div>
                </div>
        </div>
        <div key={"unit"+unit.ID.toString()} className="relative flex flex-row w-full border mb-4 rounded-b" style={{ imageRendering: '-webkit-optimize-contrast', backgroundPosition: "-40px 0", backgroundSize: "contain",backgroundRepeat: 'no-repeat', backgroundImage: `url(/img/charArt/Tex_UI_${unit.EnglishName}_CharArt${unit.ID}.png)` }}>
            <div className={`w-full h-full absolute bg-opacity-80 md:bg-opacity-0 bg-[#171e26] unit-${unit.ID}`} ></div>
            <div className='md:w-[20%]'>
                
            </div>
            <div className='z-10 flex flex-col skills gap-4 w-full pr-3 pt-5 pb-5 pl-3'>
                {skills.filter((s) => s.HeroID === unit.ID && s.AwakenType === 0 && s.SkillSlot < 10 && s.SkillLevel === 1).map((skill,index) => (
                    <div key={"skill-"+unit.ID+"-"+index} style={{boxShadow: '-2px 2px 10px 7px black'}} className={`flex level-${skill.SkillLevel} slot-${skill.SkillSlot} rounded flex-row gap-2 w-full p-2 bg-[#171e26]`}>
                        <div className='flex flex-col gap-2 w-full '>
                            <div className='customTitle text-3xl text-center flex flex-row items-center justify-between'>
                                <div className='w-[64px]'><img className='h-full w-full' src={`img/skills/Tex_${unit.EnglishName}_UI_Atlas_${skill.SkillSlot}.png`} alt={skill.SkillName}/></div>
                                <div className='w-full'>{searchKey("SkillDescription;SkillName;"+unit.ID+"0"+skill.SkillSlot)} {searchKey("SkillDescription;SkillTypeDes;"+unit.ID+"01") !== "Active" ? "("+searchKey("SkillDescription;SkillTypeDes;"+unit.ID+"01")+")":""}</div>
                            </div>
                            <div dangerouslySetInnerHTML={{__html: descriptionReplace(skill,"SkillDescription;Description1;"+unit.ID+"0"+skill.SkillSlot)}}></div>
                            <div className='basis-1/6 border rounded text-sm'>
                                {skills.filter((s) => s.HeroID === unit.ID && s.AwakenType === 0 && s.SkillSlot < 10 && s.SkillLevel !== 1 && skill.SkillSlot === s.SkillSlot).map((skill2,index2) => (
                                    <div key={"levelup-"+unit.ID+"-"+index2} className={`p-2 ${index2 % 2 === 0 ? 'bg-slate-600':''}`}>Level {skill2.SkillLevel} : {levelUpReplace(skill2.LvlUpDes,skill2.TextReplace)}</div>
                                    ))}
                            </div>
                        </div>    
                    </div>
                ))}
                {skills.filter((s) => s.HeroID === unit.ID && s.AwakenType !== 0 && s.SkillSlot < 10 && s.SkillLevel === 1).map((skill,index) => (
                    <div key={"awake"+skill.SkillID}></div>
                ))}
                <div style={{boxShadow: '-2px 2px 10px 7px black'}} className={`flex items-center rounded flex-row gap-2 w-full p-2 bg-[#171e26]`}>
                    <div className='-ml-7'>
                        <div className={`scale-50 aspect-square leaderSkill ${unit.LeaderSkill != null ? 'leaderSkillBg':''} ${getLeaderSkillIcon(unit.LeaderSkill,unit)}${unit.SkillColor}`}></div>
                    </div>
                    <div className='flex flex-col'>
                        <div className='text-3xl customTitle'>{searchKey("CommonBattle_Info_LeaderSkill")}</div>
                        <div className=''>{unit.LeaderSkill != null ? getLeaderSkillsDescription(unit.LeaderSkill,unit): searchKey("CommonBattle_Info_NoLeaderSkill")}</div>    
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}
function EsperList() {
    const {searchKey,translate,collection} = useContext(AppContext);
    const [esperList,setEsperList] = useState(hero.filter((h) => h.Enable === true && h.HeroType === "Hero").map(x => {x.checked = collection.includes(x.ID);x.show = true;return x;}));
    const [searchQ,setSearchQ] = useState("");
    const [typeList,setTypeList] = useState([{"id":4,"name":"Shimmer","show": true},{"id": 1,"name":"Inferno","show": true},{"id": 2,"name": "Wind",show: true},{"id": 3,"name":"Flow",show: true}]);
    

    const search = (e) => {
        e.preventDefault();
		let currentSearch = e.target;
        setSearchQ(currentSearch.value);
	}
    const toggleType = (e) => {
		e.preventDefault();
		let currentType = e.target;
		if(currentType.checked) {
			let temp = typeList.map((t) => {
				if(t.id.toString() === currentType.value){
					t.show = true;
				}
				return t;
			})
			setTypeList(temp)
		} else {
			let temp = typeList.map((t) => {
				if(t.id.toString() === currentType.value){
					t.show = false;
				}
				return t;
			})
			setTypeList(temp)
		}
  	}
	const toggleNone = (e,type) => {
		if(type === "type") {
			let temp = typeList.map((t) => {
				t.show = false;
				return t;
			})
			setTypeList(temp);
		}
		e.preventDefault();
    }
	const toggleAll = (e,type) => {
        if(type === "type"){
			let temp = typeList.map((t) => {
				t.show = true;
				return t;
			})
			setTypeList(temp)
		}
        e.preventDefault();
    }
	const displayStar = (nb) => {
		let stars = [];
		for(let i = 0; i < nb; i++){
			stars.push(<img key={i} className="pixel h-[24px] aspect-[13/14]" src="img/star.png" alt={nb.toString()} style={{float:'left'}}/>);
		}
		return stars;
		
	}
	
    function computedEsperSkillList() {
		let temp = [...esperList];
        temp = temp.map((esper) =>  {
            let tempEsper = {...esper}		
			if(searchQ !== "") {
				let tempType = typeList.find((t) => t.id === tempEsper.TypeID);
				if(tempType !== undefined) {
					tempEsper.show = tempType.show && (searchKey(tempEsper.Name).toLowerCase().includes(searchQ.toLowerCase()) || searchKey(tempEsper.NickName).toLowerCase().includes(searchQ.toLowerCase()))
				} else {
					tempEsper.show = searchKey(tempEsper.Name).toLowerCase().includes(searchQ.toLowerCase()) || searchKey(tempEsper.NickName).toLowerCase().includes(searchQ.toLowerCase())
				}

			} else {
				let tempType = typeList.find((t) => t.id === tempEsper.TypeID);
				if(tempType !== undefined) {
					tempEsper.show = tempType.show;
				} else {
					console.log("tempType undefined"+tempEsper.TypeID);
				}
					
			}
			
            return tempEsper
        })
        setEsperList(temp);
        return temp;
    }
    useEffect(() => {
		computedEsperSkillList()
    },[searchQ,typeList]);

    useEffect(() => {
        const timeOutId = setTimeout(() => computedEsperSkillList(), 500);
        return () => clearTimeout(timeOutId);
    }, [searchQ]);

    return (
        <>
        <div className='filter flex pb-2'>
            <div className="w-48">
                <h3>Type</h3>
                <button onClick={(e) => toggleAll(e, "type")}>{translate("All")}</button> / <button onClick={(e) => toggleNone(e, "type")}>{translate("None")}</button>
                <div className="flex flex-col">{typeList !== [] ?
                    typeList.map((type) => (
                        <div key={"typeList-" + type.name} id={type.id.toString()} className='flex flex-row gap-2 items-center'>
                            <div><input id={`filter-type${type.id}`} onChange={toggleType} name="type[]" checked={type.show} value={type.id.toString()} type="checkbox" className="h-4 w-4 mt-2 border-gray-300 rounded text-blue-400 focus:ring-indigo-500" /></div>
                            <div>
                                <label htmlFor={`filter-type${type.id}`} className="ml-3 min-w-0 justify-start">
                                    <img className='pixel h-[24px] aspect-[13/14]' src={'img/type/UnitJob' + type.id.toString() + '.png'} alt={type.name} style={{ float: 'left' }} />
                                    {translate(type.name.toUpperCase())}
                                </label>
                            </div>
                        </div>
                    )) : ''}
                </div>
            </div>
            <div className="w-48">
                <h3>{translate('Search')}</h3>
                <div><input type="text" onChange={(e) => search(e)} placeholder={"Name or NickName..."} className='bg-[#212932]' /></div>
            </div>
        </div>
        <div className='flex flex-col mb-10 rounded pb-5'>
            {esperList.filter((h) => h.show === true).map((unit, index) => (
                <EsperData key={unit.ID} unit={unit} />
            ))}        
        </div>
        </>
    )
}
export default EsperList;